import EventDispatcher from "../../../../util/EventDispatcher";
import GUIDUtil from "../../../../util/GUIDUtil";
import { isUndefined } from "../../../../util/TypeUtil";
import StoryModelEvent from "./StoryModelEvent"

export default class StoryElement extends EventDispatcher {

    /**
     * Initialize a new StoryElement
     * @param {int} id
     * @param {type} data
     * @param {type} unlockCondition
     * @param {type} availableCondition
     * @param {type} isEnd
     * @returns {StoryElement}
     */
    constructor(id, data, unlockCondition, availableCondition, isEnd) {
        super();

        //Handle default parameters
        isEnd = isUndefined(isEnd) ? false : isEnd;
        unlockCondition = isUndefined(unlockCondition) ? null : unlockCondition;
        availableCondition = isUndefined(availableCondition) ? null : availableCondition;

        //Set object properties
        this.id = id;
        this._label = null;
        this._data = data;
        this._metadata = undefined;
        this._unlockCondition = unlockCondition;
        this._availableCondition = availableCondition;
        this._retained = false;
        this._end = isEnd;
    }
    isEnd() {
        return this._end;
    }
    setEnd(val) {
        this._end = val;
        this.dispatchEvent(StoryModelEvent.STORY_ELEMENT_UPDATED, this);
        this.update();
    }
    isRetained() {
        return this._retained;
    }
    setRetained(val) {
        this._retained = val;
        this.dispatchEvent(StoryModelEvent.STORY_ELEMENT_UPDATED, this);
        this.update();
    }
    getAvailableCondition() {
        return this._availableCondition;
    }
    setAvailableCondition(val) {
        this._availableCondition = val;
        this.dispatchEvent(StoryModelEvent.STORY_ELEMENT_UPDATED, this);
        this.update();
    }
    getUnlockCondition() {
        return this._unlockCondition;
    }
    setUnlockCondition(val) {
        this._unlockCondition = val;
        this.dispatchEvent(StoryModelEvent.STORY_ELEMENT_UPDATED, this);
        this.update();
    }
    getData() {
        return this._data;
    }
    setData(val) {
        this._data = val;
        this.dispatchEvent(StoryModelEvent.STORY_ELEMENT_UPDATED, this);
        this.update();
    }
    getMetadata() {
        return this._metadata;
    }
    setMetadata(val) {
        this._metadata = val;
        this.dispatchEvent(StoryModelEvent.STORY_ELEMENT_UPDATED, this);
        this.update();
    }
    getLabel() {
        if (this._label === null || this._label === "") {
            return "" + this.id;
        }
        return this._label;
    }
    setLabel(val) {
        this._label = val;
        this.dispatchEvent(StoryModelEvent.STORY_ELEMENT_UPDATED, this);
        this.update();
    }
    /**
     * Evaluate the unlock condition of the StoryElement
     * @param {function} solver
     * @returns {Boolean}
     */
    evaluateUnlockCondition(solver) {
        if (this._unlockCondition) {
            return this._unlockCondition.solve(solver);
        } else {
            return true;
        }
    }
    /**
     * Evaluate the available condition of the StoryElement
     * @param {function} solver
     * @returns {Boolean}
     */
    evaluateAvailableCondition(solver) {
        if (this._availableCondition) {
            return this._availableCondition.solve(solver);
        } else {
            return true;
        }
    }
    /**
     * Abstract function that can be overriden by subclasses to add functionality after a property is updated
     * @returns {undefined}
     */
    update() {
    }
    
    static generateID() {
        return GUIDUtil.generateGUID();
    }
}









